import { Component, EventEmitter, OnInit, Output, Renderer2, ViewChild, AfterViewInit, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvMarketplaceShoppingCartComponent } from '../cv-marketplace-shopping-cart/cv-marketplace-shopping-cart.component';
import { CvNumberLocalizePipe } from '../../../../reusables/pipes/cv-number-localize.pipe';
import { debounce } from 'lodash';
import { NgbCarousel, NgbCarouselConfig, NgbSlide } from '@ng-bootstrap/ng-bootstrap';
import { PointStoreProductOrderService } from 'src/app/gamification/marketplace/agent-side/services/point-store-product-order.service';
import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { ThumbnailSlideService } from 'src/app/reusables/services/thumbnail-slide-service';
import { PointStoreProductItem } from 'src/shared/models/point-store-product.model';

@Component({
  selector: 'cv-marketplace-shopping-cart-carousel',
  templateUrl: './cv-marketplace-shopping-cart-carousel.component.html',
  styleUrls: ['./cv-marketplace-shopping-cart-carousel.component.scss']
})
export class CvMarketplaceShoppingCartCarouselComponent implements OnInit, AfterViewInit, OnChanges {

  @Output() showValidationMsg = new EventEmitter<any>();
  @Input() contentDisplayed: boolean;

  pscs = null;
  productQuantity: number = 1;
  isQtyEmpty: boolean = false;
  showEmptyQtyMssg: boolean = false;
  isVariationSelected: boolean = true;
  selectedVariation = null;
  _localizationStrings = new Map();
  loading: boolean = false;
  highlightCartItem: boolean = false;
  drawerTimeOut = null;
  lastAdded = null;
  pspos = null;
  slideVariations = [];
  variationRealPrice: number = 0;
  variationPrice: number = 0;
  variationSale: string = '';
  previousSelectedQty: number = 1;
  displayedProduct = null;
  allowedQuantity: number = 20;
  carouselIndex: number = 0;
  computedCarouselItems: Array<PointStoreProductItem> = [];
  disableSliderButton: boolean = true;
  carouselContainer: HTMLElement | undefined = undefined;

  disableAddToCartButton: boolean = false;

  isCxone: boolean = false;
  @ViewChild(NgbCarousel) carousel: NgbCarousel;
  defaultCarouselInterval: number = 7000;
  shoppingCartsService = null;
  addCarProdutIdPrev = null;

  constructor(
    private cvNumberLocalize: CvNumberLocalizePipe,
    private pointStoreProductOrderService: PointStoreProductOrderService,
    private shoppingCartService: ShoppingCartService,
    private cvLocalizationService: CVLocalizationService,
    config: NgbCarouselConfig,
    private marketplaceShoppingCartComponent: CvMarketplaceShoppingCartComponent,
    private dialogService: CvCustomDialogService,
    private cvConfigurationService: CvConfigurationService,
    private renderer: Renderer2,
    private marketShoppingCartService: ThumbnailSlideService,

  ) {
    this.pspos = pointStoreProductOrderService.pointStoreProductOrderObj;
    this.pscs = shoppingCartService.shoppingCartObj;
    config.interval = this.defaultCarouselInterval;
    config.pauseOnHover = true;
    config.showNavigationArrows = false;
    this.isCxone = this.cvConfigurationService.isCxOne;
    this.shoppingCartsService = new ThumbnailSlideService();
  }  

  ngOnChanges(changes: SimpleChanges) {
    if(changes.contentDisplayed.previousValue && !changes.contentDisplayed.currentValue){
      //enable autoplay with the default interval
      this.carousel.interval = this.defaultCarouselInterval;
    }
  }

  ngAfterViewInit(): void {
    this.setFirstSlideReadMore();
  }

  ngOnInit(): void {
    this.shoppingCartsService.updateResolution();
    this.disableSliderBtn();
    this.computedCarouselItems = this.sortByCarousel();
    this.setSlideVariations();
    this.loadLocalizations();
    this.setQtyInputEvent();
    this.carouselContainer = <HTMLElement>document.getElementsByClassName("carousel-container")[0];
  }

  loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
      this._localizationStrings = map;
    });
  }

  /**
      * Returns the localization for the provided Key, or defaultValue if missing.
      * @param key String's Key from the *.Language Section for this module
      * @param defaultValue String returned if localizations didn't load, or the key is missing.
      */
  getLocalizationString(key, defaultValue) {
    if (this._localizationStrings && this._localizationStrings.has(key))
      return this._localizationStrings.get(key);
    return defaultValue;
  }

  setQtyInputEvent() {
    //The following code snippet is to allow the numeric input of cxone to remain empty until the user enters a valid quantity:
    setTimeout(() => {
      let inputs = document.getElementsByClassName('numeric-selector-value');
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener("blur", () => {
          if (this.isQtyEmpty) {
            let input: any = document.getElementsByClassName('numeric-selector-value');
            input[this.carouselIndex].value = '';
          }
        })
      }
    }, 0);
  }

  resetQtyInput() {
    let input: any = document.getElementsByClassName('numeric-selector-value');
    this.productQuantity = 1;
    this.previousSelectedQty = this.productQuantity;
    input[this.carouselIndex].value = this.previousSelectedQty;
    this.isQtyEmpty = false;
    this.showEmptyQtyMssg = false;
    setTimeout(() => {
      this.setQtyInputEvent();
    }, 0);
  }

  onSlide(event) {
    this.setSlideVariations(event);
    this.selectedVariation = null;
    this.isVariationSelected = true;
    this.productQuantity = 1;
    this.previousSelectedQty = this.productQuantity;
    this.isQtyEmpty = false;
    this.showEmptyQtyMssg = false;
    this.slideVariationsReadMore(event);
    this.checkCarouselResponsive();
  }

  setSlideVariations(event = null) {
    if (this.computedCarouselItems != null && this.computedCarouselItems.length > 0) {
      let currIndex = null;
      let prevIndex = null;
      this.slideVariations = [];

      if (event != null) {
        currIndex = parseInt(event.current.replace("slideId_", ""), 10);
        prevIndex = parseInt(event.prev.replace("slideId_", ""), 10);
        let inputs: any = document.getElementsByClassName('numeric-selector-value');
        if (this.isQtyEmpty)
          inputs[prevIndex].value = this.productQuantity;
        this.carouselIndex = currIndex;
        this.displayedProduct = this.computedCarouselItems[currIndex];
        this.displayProductVariations();
        this.displayDefaultImage(this.displayedProduct);
      } else {
        setTimeout(() => {
          let carouselElementsAtr = document.querySelectorAll('[atrp]');
          if (carouselElementsAtr && carouselElementsAtr.length) {
            let productID = carouselElementsAtr[0].getAttribute('atrp');
            this.displayedProduct = this.computedCarouselItems?.find(({ PointStoreProductID }) => PointStoreProductID == Number(productID));
            this.displayProductVariations();
            this.displayDefaultImage(this.displayedProduct);
          }
        }, 0);
      }
    } else {
      setTimeout(() => {
        this.setSlideVariations();
      }, 500);
    }
  }

  displayProductVariations(): void {
    this.slideVariations = [];
    if (this.displayedProduct?.HasProductVariations && this.displayedProduct?.VariationsData.length > 0) {
      this.displayedProduct?.VariationsData.forEach(variation => {
        this.slideVariations.push(variation);
      });
    }

    if (this.displayedProduct.MultipleImagesData != null && this.displayedProduct.MultipleImagesData.length > 0) {
      setTimeout(() => {
        let thumbnailList = document.getElementsByClassName('thumbnail-' + this.displayedProduct.PointStoreProductID);
        let lastThumbnail = <HTMLElement>thumbnailList[thumbnailList.length - 1];
        lastThumbnail.style.marginRight = "0px";
      }, 0);
    }
    const products = this.shoppingCartsService.getProducts();
    const productOne = products.find(product => product.id === this.displayedProduct.PointStoreProductID);
    if (productOne) { 
        this.shoppingCartsService.setButtonRight(productOne.buttonRight);
        this.shoppingCartsService.setButtonleft(productOne.buttonleft);
    } else { 
        this.shoppingCartsService.updateResolution();
        this.disableSliderBtn(); 
    }   
  }

  sliderChange() { 
    const slider = document.getElementById(`slider_${3439}`);
    slider.scrollLeft = 0;
  }
  
  displayDefaultImage(product: any): void {
    if (this.isMainImageEmpty(product)) {
      let images = product.MultipleImagesData;
      if (images.length > 0) {
        this.setSelectedImg(product.PointStoreProductID, images[0].PointStoreProductImageID);
      }
    } else {
      this.setSelectedImg(product.PointStoreProductID, product.ProductImageID);
    }
  }

  displayDefaultImageByAction(): void {
    if (this.selectedVariation) {
      let itemFromCarousel = this.computedCarouselItems?.find((i) => i.PointStoreProductID === this.selectedVariation.PointStoreProductID);
      if (itemFromCarousel && itemFromCarousel.MultipleImagesData) {
        let variationFromCarousel = itemFromCarousel.MultipleImagesData.find((v) => v.PointStoreProductVariationID === this.selectedVariation.PointStoreProductVariationID);
        if (variationFromCarousel) {
          this.setSelectedImg(variationFromCarousel.PointStoreProductID, variationFromCarousel.PointStoreProductImageID);
        }
      }
    } else {
      let sliders = document.getElementsByClassName('carousel-item active');
      if (sliders) {
        const currIndex = parseInt(sliders[0].id.replace('slide-slideId_', ''), 10);
        const productDisplayed = this.computedCarouselItems[currIndex];
        this.displayDefaultImage(productDisplayed);
      }
    }
  }

  isCurrentSale(item: any): boolean {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 1);
    }

    return false;
  }

  isOutOfStock(product): any {
    if (product != null) {
      if (product.HasProductVariations) {
        if (this.selectedVariation != null) {
          //session cart
          const sessionCart = this.shoppingCartService.shoppingCartObj.pointStoreCart.pointStoreProducts;
          let selectedVariation = product.VariationsData.find((v) => { return v.PointStoreProductVariationID === this.selectedVariation.PointStoreProductVariationID; });

          //find the current product variation in the session cart
          let validateSessionCart = sessionCart?.find(cart => cart.Variation === this.selectedVariation.PointStoreProductVariationID);
          if (selectedVariation !== null && (selectedVariation?.VariationQuantity === 0 ||
            selectedVariation?.VariationQuantity < 0 ||
            selectedVariation?.VariationQuantity === validateSessionCart?.Quantity//if is the same means the variation is currently unavailable
          )) {
            return true;
          }
        } else {
          const isOutOfStock = product.VariationsData?.reduce((acc, curr) => {
            const quantity = curr.VariationQuantity === null ? 1 : curr.VariationQuantity;//null means unlimited so consider 1 as default value
            return acc + quantity
          }, 0);
          return isOutOfStock === 0 ? true : false;
        }
      } else {
        return product.Quantity == 0 || product.Quantity < 0;
      }
    } else
      return false;
  }

  async addCartProduct(product, quantity) {
    this.addCarProdutIdPrev = product.PointStoreProductID;
    this.disableAddToCartButton = true;
    let invalidInputs = false;
    if (this.isQtyEmpty) {
      let inputs: any = document.getElementsByClassName('numeric-selector-value');
      inputs[this.carouselIndex].value = "";
      this.showEmptyQtyMssg = true;
      invalidInputs = true;
    }
    if (product.HasProductVariations && (this.selectedVariation == null || this.selectedVariation < 1)) {
      this.isVariationSelected = false;
      invalidInputs = true;
    } else {
      this.isVariationSelected = true;
    }
    this.checkCarouselErrors();
    if (invalidInputs) {
      this.disableAddToCartButton = false;
      return;
    }
    if (!(this.pscs.pointStoreCart.pointStoreProducts.findIndex((p) => { return p.ProductID === product.PointStoreProductID; }) > -1)) {
      this.highlightCartItem = true;
    }

    this.pscs.shoppingCartShowLoader = true;

    //check session cart
    await this.shoppingCartService.getSessionCart();

    if (!this.checkAvailityToAddItemsToCart(product, quantity, this.selectedVariation?.PointStoreProductVariationID)) {
      this.pscs.shoppingCartShowLoader = false;
      this.disableAddToCartButton = false;
      return;
    }
    // this.shoppingCartService.addProductsToCart(product, quantity, this.selectedVariation).then((result: any) => {
    this.shoppingCartService.addProductsToCart(product, quantity, this.selectedVariation?.PointStoreProductVariationID).then((result: any) => {
      if (result) {
        const products = this.shoppingCartsService.getProducts();
        const productOne = products.find(productGet => productGet.id === this.addCarProdutIdPrev);
        if (productOne ) { 
            this.shoppingCartsService.deleteProduct(productOne.id);
        }
        this.addCarProdutIdPrev = null;
        if (this.computedCarouselItems?.findIndex((c) => { return c.PointStoreProductID == product.PointStoreProductID; }) > -1) {
          this.shoppingCartService.getCarouselItems();
          setTimeout(() => {
            this.displayDefaultImageByAction();
          }, 50);
        }
        // if (!this.pscs.pointStoreVisibleContent.showProductSectionLanding && !this.pscs.pointStoreVisibleContent.showOrdersPage) {
        //   this.pscs.pointStoreDetailedViewProduct.Quantity = this.pscs.pointStoreProducts.find((p) => { return p.PointStoreProductID == this.pscs.pointStoreDetailedViewProduct.PointStoreProductID; }).Quantity;
        // }
        this.lastAdded = product;
        this.productQuantity = 1;
        this.previousSelectedQty = this.productQuantity;
        this.resetQtyInput;
        this.isVariationSelected = true;
        this.pscs.pointStoreVisibleContent.showPopUpAddedCart = true;
        setTimeout(() => {
          this.pscs.shoppingCartShowLoader = false;
          this.disableAddToCartButton = false;
          this.marketplaceShoppingCartComponent.addCartProduct();
        }, 2000);
      } else {
        setTimeout(() => {
          this.pscs.shoppingCartShowLoader = false;
          this.disableAddToCartButton = false;
        }, 2000);
      }
      setTimeout(() => {
        this.setQtyInputEvent();
      }, 0);
    });
  }

  setSelectedImg(productID, imageID) {
    let thumbnails = document.getElementsByClassName('thumbnail-' + productID);
    for (let i = 0; i < thumbnails.length; i++) {
      thumbnails[i].classList.remove('img-selected');
    }
    let thumbnailImg = <HTMLImageElement>document.getElementById(imageID);
    if (thumbnailImg) {
      thumbnailImg.classList.add('img-selected');
    }

    let selectedImg = <HTMLImageElement>document.getElementById('selected-image-' + productID);
    if (selectedImg) {
      selectedImg.src = '../Admin/ImageResizer.aspx?imgid=' + imageID + '&w=auto&h=388'
    }

  }

  goToNextImg(productID) {
    let selectedImg = null;
    let nextImage = null;
    let thumbnails = document.getElementsByClassName('thumbnail-' + productID);
    for (let i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i].classList.contains('img-selected')) {
        selectedImg = thumbnails[i];
        selectedImg.classList.remove('img-selected');
        nextImage = thumbnails[i + 1];
        if (nextImage == null) {
          nextImage = thumbnails[0];
        }
      }
    }
    nextImage.classList.add('img-selected');
    let mainImage = <HTMLImageElement>document.getElementById('selected-image-' + productID);
    mainImage.src = nextImage.src;
  }

  goToPrevImg(productID) {
    let selectedImg = null;
    let prevImage = null;
    let thumbnails = document.getElementsByClassName('thumbnail-' + productID);
    for (let i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i].classList.contains('img-selected')) {
        selectedImg = thumbnails[i];
        selectedImg.classList.remove('img-selected');
        prevImage = thumbnails[i - 1];
        if (prevImage == null) {
          prevImage = thumbnails[thumbnails.length - 1];
        }
      }
    }
    prevImage.classList.add('img-selected');
    let mainImage = <HTMLImageElement>document.getElementById('selected-image-' + productID);
    mainImage.src = prevImage.src;
  }

  setVariationData(product, index) {
    this.productQuantity = 1;
    this.previousSelectedQty = this.productQuantity;
    let inputs: any = document.getElementsByClassName('numeric-selector-value');
    inputs[this.carouselIndex].value = this.previousSelectedQty;
    this.isQtyEmpty = false;
    this.showEmptyQtyMssg = false;
    this.variationRealPrice = this.getVariationRealPrice(product);
    this.variationPrice = this.getVariationPrice(product);
    this.variationSale = this.getVariationSale(product);

    this.isVariationSelected = true;

    this.checkCarouselResponsive();

    if (product.HasProductVariations && product.VariationsData.length > 0 && product.MultipleImagesData != null && product.MultipleImagesData.length > 0) {
      let matchFound = false;

      //Looping through the product images (main product and variations)
      product.MultipleImagesData.forEach(image => {
        if (image.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID) {
          matchFound = true;
          this.setSelectedImg(product.PointStoreProductID, image.PointStoreProductImageID);
        }
      });

      //If an image wasn't found for the selected variation, the main product image is displayed instead
      if (!matchFound) {
        this.setSelectedImg(product.PointStoreProductID, product.ProductImageID);
      }
    }
  }

  getVariationRealPrice(product) {
    let variation = null;
    product.VariationsData.forEach(v => {
      if (v.PointStoreProductID == this.selectedVariation.PointStoreProductID && v.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID)
        variation = v;
    });
    if (product.HasVariationPrices) {
      if (variation.VariationOnSale && this.isCurrentSale(product)) {
        let price = variation.VariationPrice == null ? product.Price : variation.VariationPrice;
        return new CvNumberLocalizePipe().transform(Math.ceil(price - (price * product.Sale) / 100));
      } else {
        return variation.VariationPrice == null ? new CvNumberLocalizePipe().transform(Math.ceil(product.Price)) : new CvNumberLocalizePipe().transform(Math.ceil(variation.VariationPrice));
      }
    } else {
      if (variation.VariationOnSale && this.isCurrentSale(product))
        return new CvNumberLocalizePipe().transform(Math.ceil(product.Price - (product.Price * product.Sale) / 100));
      else
        return new CvNumberLocalizePipe().transform(Math.ceil(product.Price));
    }
  }

  getVariationPrice(product) {
    let variation = null;
    product.VariationsData.forEach(v => {
      if (v.PointStoreProductID == this.selectedVariation.PointStoreProductID && v.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID)
        variation = v;
    });
    if (product.HasVariationPrices) {
      let price = variation.VariationPrice == null ? product.Price : variation.VariationPrice;
      return variation.VariationOnSale ? new CvNumberLocalizePipe().transform(price) : '';
    } else {
      return variation.VariationOnSale ? new CvNumberLocalizePipe().transform(product.Price) : '';
    }
  }

  getVariationSale(product) {
    let variation = null;
    product.VariationsData.forEach(v => {
      if (v.PointStoreProductID == this.selectedVariation.PointStoreProductID && v.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID)
        variation = v;
    });
    if (variation == null)
      return;

    return variation.VariationOnSale ? '(' + product.Sale + '% ' + this.getLocalizationString("OFF", "OFF") + ')' : '';
  }

  getProductStock(product) {
    if (product.HasProductVariations) {
      if (this.selectedVariation != null) {
        let variationQty = null;
        product.VariationsData.forEach(variaton => {
          if (variaton.PointStoreProductID == this.selectedVariation.PointStoreProductID && variaton.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID)
            variationQty = variaton.VariationQuantity;
        });
        if (variationQty > 0 && variationQty != null)
          return variationQty > 20 ? 20 : variationQty;
        else
          return 20
      } else {
        return 20;
      }
    } else {
      if (product.Quantity > 0 && product.Quantity != null)
        return product.Quantity > 20 ? 20 : product.Quantity;
      else
        return 20
    }
  }

  validateValue(event, product) {
    let inputs: any = document.getElementsByClassName('numeric-selector-value');
    let value = inputs[this.carouselIndex].value;
    //if value is not an integer:
    if (!(Number.isInteger(Number(value)) && Number(value) > 0)) {
      //if it is anything but the backspace then replace it with the previous valid value.
      if (event.keyCode != 8 && event.keyCode != 46) {
        this.productQuantity = this.previousSelectedQty;
        inputs[this.carouselIndex].value = this.productQuantity;
        this.isQtyEmpty = this.productQuantity == null;
        this.showEmptyQtyMssg = this.productQuantity == null;
      } else {
        this.isQtyEmpty = true;
        this.productQuantity = null;
        this.previousSelectedQty = null;
      }
      //the value is an integer greater than 0:
    } else {
      let maxStock = this.getProductStock(product);
      //if the value entered is greater than the available stock, set the maximum stock instead.
      if (Number(value) > maxStock) {
        this.productQuantity = maxStock;
        this.previousSelectedQty = maxStock;
        inputs[this.carouselIndex].value = maxStock;
      } else {
        this.productQuantity = value;
        this.previousSelectedQty = this.productQuantity;
        inputs[this.carouselIndex].value = this.previousSelectedQty;
      }
      this.isQtyEmpty = false;
      this.showEmptyQtyMssg = false;
      this.checkCarouselResponsive();
    }
  }

  checkCarouselResponsive() {
    if (window.matchMedia("(max-width: 1600px)").matches)
      this.carouselContainer.style.height = "410px";
  }

  checkCarouselErrors(): void {
    if (this.carouselContainer === undefined) return;
  
    const isSmallScreen = window.matchMedia("(max-width: 1600px)").matches;
    const shouldSetHeight = !this.isVariationSelected && this.showEmptyQtyMssg && isSmallScreen;
  
    this.carouselContainer.style.height = shouldSetHeight ? "430px" : "410px";
  }

  checkQtyInput($event, product) {
    //Quantity changed by clicking + or - button
    if (Number.isInteger($event) && Number($event) > 0) {
      if (this.isQtyEmpty) {
        let inputs: any = document.getElementsByClassName('numeric-selector-value');
        inputs[this.carouselIndex].value = '';
        return
      }
      else
        this.validateValue($event, product);
    } else {
      //Manually entered value
      setTimeout(() => {
        this.validateValue($event, product);
      }, 0);
    }
  }

  disableSliderBtn() {
    if (this.displayedProduct != null) {
      let thumbnailList = document.getElementsByClassName('thumbnail-' + this.displayedProduct.PointStoreProductID);
      this.shoppingCartsService.disableSliderBtn(thumbnailList.length);
    } else {
      this.shoppingCartsService.disableSliderBtn(0);
    }
  }
  
  sortByCarousel(): any[] {
      const seen = new Set();
      const data: Array<PointStoreProductItem> = [...this.pscs.pointStoreProductCarouselItems, ...this.pscs.pointStoreProducts];
      const nonExpiredItems = data?.filter((item)=> !item.CarouselEnd || new Date() < new Date(item.CarouselEnd));
      const filteredArray = nonExpiredItems.filter(product => {
        const duplicated = seen.has(product.PointStoreProductID);
        seen.add(product.PointStoreProductID);
        return !duplicated;
      });
      return filteredArray.slice(0, 5);
  }
  
  wishlistAction(product) {
    if (product.isInWhisList)
      this.removeFromWishlist(product)
    else
      this.addToWishlistProduct(product);
  }

  async removeFromWishlist(product) {
    let response = await this.shoppingCartService.removeWishlistItem(product);
    if (response)
      this.showValidationMsg.emit({ event: event, isAdding: false });
  }

  async addToWishlistProduct(product) {
    let response = await this.shoppingCartService.addWishlistItem(product);
    if (response)
      this.showValidationMsg.emit({ event: event, isAdding: true });
  }

  getProductPrices(product) {
    if (product != null) {
      if (product.HasProductVariations && product.HasVariationPrices && product.VariationsData != null && product.VariationsData.length) {
        let initialVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue < currValue ? prev : curr;
        });
        let lastVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue > currValue ? prev : curr;
        });
        let initialVariationPrice = initialVariation.VariationOnSale ? (initialVariation.VariationPrice - (initialVariation.VariationPrice * (product.Sale / 100))) : initialVariation.VariationPrice;
        let lastVariationPrice = lastVariation.VariationOnSale ? (lastVariation.VariationPrice - (lastVariation.VariationPrice * (product.Sale / 100))) : lastVariation.VariationPrice;
        return new CvNumberLocalizePipe().transform(Math.ceil(initialVariationPrice)) + " - " + new CvNumberLocalizePipe().transform(Math.ceil(lastVariationPrice));
      }
      else if (product.Sale != null && this.isCurrentSale(product)) {
        return product.CalculatedRealPrice;
      } else
        return product.Price;
    }
  }

  checkAvailityToAddItemsToCart(product, quantity, variationId): boolean {
    let isAvaliable: boolean = true;
    let totalItems: number = 0;
    //it is a product with variation or not
    let productCart = variationId == null ?
      this.pscs.pointStoreCart.pointStoreProducts.find(x => x.ProductID == product.PointStoreProductID) :
      this.pscs.pointStoreCart.pointStoreProducts.find(x => x.ProductID == product.PointStoreProductID && x.Variation == variationId);

    //is the product in the cart?
    if (productCart) {
      totalItems = productCart.Quantity + Number(quantity);
      isAvaliable = totalItems > this.allowedQuantity ? false : true;
    } else {
      totalItems = quantity;
      isAvaliable = totalItems > this.allowedQuantity ? false : true;
    }

    //not available?
    if (!isAvaliable) {
      if (this.cvConfigurationService.isCxOne) {
        this.dialogService.showDialog(
          this.getLocalizationString("Warning_Text", "Warning"),
          this.getLocalizationString("Quantity_Added_Exceeds_Permitted_Limit", 'The quantity added exceeds the permitted limit.'),
          1,
          '',
          this.getLocalizationString("Ok", "Ok"),
          true,
          () => { },
          () => { }
        );
      } else {
        showErrorMessage(this.getLocalizationString("Quantity_Added_Exceeds_Permitted_Limit", 'The quantity added exceeds the permitted limit.'));
      }
    }
    return isAvaliable;
  }

  isMainImageEmpty(product): boolean {
    let status = false;
    if (product.HasMultipleImages && (product.ProductImageID == 0 || product.ProductImageID == null)) {
      status = true;
    } else {
      status = false;
    }
    return status;
  }

  /**
   * Function to add a read more text to the first slide
   * is set this way because the Carousel onSlide event is triggered only when the slide is changed.
   * @returns void
   */
  setFirstSlideReadMore(): void {
    if (this.computedCarouselItems != null && this.computedCarouselItems.length > 0) {
      const firstSlide: NgbSlide = this.carousel?.slides.first;
      //create a smooth animation
      window.requestAnimationFrame(() => {
        this.createReadMoreLink(firstSlide.id);
      });
    }
  }

  /**
   * Function to add a read more text to the slides when the onSlide event is fired.
   * @param event carousel event
   * @returns void
   */
  slideVariationsReadMore(event): void {
    if (!event) {
      return;
    }
    if (this.computedCarouselItems != null && this.computedCarouselItems.length > 0) {
      //create a smooth animation
      window.requestAnimationFrame(() => {
        this.createReadMoreLink(event.current);
      });
    }
  }

  /**
   * HostListener to add read more when window resizes
   */
  @HostListener('window:resize', ['$event'])
  public onResize(): void {
    this.shoppingCartsService.updateResolution();
    this.disableSliderBtn();
    const products = this.shoppingCartsService.getProducts();
    const productOne = products.find(productGet => productGet.id === this.displayedProduct?.PointStoreProductID);
    if (productOne) { 
        this.shoppingCartsService.setButtonRight(productOne.buttonRight);
        this.shoppingCartsService.setButtonleft(productOne.buttonleft);
        let thumbnailList = document.getElementsByClassName('thumbnail-' + this.displayedProduct.PointStoreProductID);
        this.shoppingCartsService.changeResolution(productOne, thumbnailList.length);  
    }
    //debounce to avoid significant calls
    let check = debounce(() => {
      const activeSlide = this.carousel?.activeId;
      this.createReadMoreLink(activeSlide)
    }, 1000);

    //create a smooth animation
    window.requestAnimationFrame(() => {
      check();
    });

    this.checkCarouselErrors();
  }

  /**
   * 
   * @param slideId index of the slide
   */
  createReadMoreLink(slideId: string) {
    let index = parseInt(slideId.replace("slideId_", ""), 10);
    const element: HTMLElement = document.getElementById(`prodDescription_${index}`);
    const maxLines:number = 2;
    if (element) {
      //timeout to get elements props
      setTimeout(() => {
        element.innerHTML = this.computedCarouselItems[index].Description;
        //get number of lines based on the line-height
        const elementLineHeight = parseInt(window.getComputedStyle(element).getPropertyValue('line-height'));
        const numberOfLines = Math.floor(element.offsetHeight / elementLineHeight);
        const maxheight = elementLineHeight * maxLines;
        let divContent = element.textContent || element.innerText;
        //the Read More link will only be added if NumberOfLines is greater than 2.
        if (numberOfLines > maxLines) {
          this.truncateText(divContent, element, maxheight, index);
        }
      }, 0);
    }
  }

  /**
   * Function to truncate the text of the div, setting the exact number of lines defined and creating a new span within the div.
   * @param text div content
   * @param element product description div
   * @param maxheight div max height calculated by maxLines
   * @param index slide index
   */
  truncateText(text: string, element: HTMLElement, maxheight, index): void {
    //read more localization
    const readMoreText = this.getLocalizationString("Read_More", "Read more");
    //split the divText by spaces and line breaks
    let words = text.split(/(\s+|\n)/);
    let truncatedText = '';
    let linkAdded = false;

    for (let word of words) {
      const testText = `${truncatedText}${word}`;

      // Include line breaks if the current word is a line break
      if (word === '\n') {
        element.innerHTML = testText.trim();
      } else {
        element.innerHTML = `${testText} `;
      }

      //Check if the client height exceeds maxheight
      if (element.clientHeight > maxheight) {
        //trim to avoid extra space at the end
        truncatedText = truncatedText.trim();

        if (!linkAdded) {
          //Add 'Read More' link at the end of the truncated text
          const readMoreLink = this.renderer.createElement('span');
          this.renderer.appendChild(readMoreLink, this.renderer.createText(` ${readMoreText}`));

          //remove some characters based on the read more localization text
          const charactersToRemove = readMoreText.length + 5;
          truncatedText = truncatedText.slice(0, -charactersToRemove).trim();
          element.innerHTML = `${truncatedText}...`;

          //create the span element
          this.renderer.appendChild(element, readMoreLink);
          this.renderer.listen(readMoreLink, 'click', (event) => {
            //disable autoplay
            this.carousel.interval = 0;
            //display the selected product on the expanded view
            this.pscs.shoppingCartIsProductSelected = true;
            this.pscs.pointStoreDetailedViewProduct = this.computedCarouselItems[index];
          })
          linkAdded = true;
        }
        break; //exit the loop if maxheight is exceeded
      }
      truncatedText = testText;
    }

    //validate if the link needs to be added
    if (!linkAdded) {
      element.innerHTML = truncatedText.trim();
    }
  }

  getVariantValidationMessage(variationType: string) {
    const defaultText = `Please select a variation of ${variationType}`;
    const localizedMessage = this.getLocalizationString('Please_Select_A_Variation', defaultText);
    return localizedMessage.replaceAll("{0}", this.getLocalizationString(variationType, variationType));
  }
}
